import { testEventHasVirtDuration } from '@racemap/utilities/functions/timing';
import _ from 'lodash';
import type { FC } from 'react';
import { useStore } from '../../../store/reducers';
import { Devider } from '../../BasicComponents/Devider/Devider';
import { TeamTargetPanel } from '../TeamTargetPanel/TeamTargetPanel';
import { appendNoneTags } from './Columns/TagCol';
import { TableBody } from './TableBody';

interface Props {
  embedded: boolean;
}

export const Table: FC<Props> = ({ embedded }) => {
  const eventData = useStore((s) => s.leaderboard.getter.selectedEventData());

  if (eventData == null) return <></>;
  const { eventObject, starterData, tags } = eventData;
  const eventDataWithNoneTags = appendNoneTags(starterData, tags);

  const teamTarget = eventObject.modules.timing.teamTarget;
  const totalDistance = _.sumBy(eventDataWithNoneTags.starters, (i) =>
    i.progress > 0 ? i.progress : 0,
  );
  const eventHasVirtDuration = testEventHasVirtDuration(eventObject);
  const unit = eventObject.playerOptions.unitType;

  return (
    <>
      {teamTarget.enabled && !eventHasVirtDuration && (
        <>
          <TeamTargetPanel teamTarget={teamTarget} totalDistance={totalDistance} unit={unit} />
          <Devider style={{ marginBottom: 0 }} />
        </>
      )}
      <TableBody embedded={embedded} />
    </>
  );
};
